module.exports = __webpack_public_path__ + "images/emoji/worried.965bc69bf8e457e32f42.png";